import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminMcpUsage = {
  index: async(props) => {
    const { default: McpUsageIndex } = await import('@/vue_widgets/admin/mcp_usage/index.vue')
    createVueApp(McpUsageIndex, { props })
  }
}
